import { MiniKit } from "@worldcoin/minikit-js";
import { type ReactNode, useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { useShallow } from "zustand/shallow";
import Spinner from "@/components/spinner";
import { CONSTANTS } from "./constants";
import { useAuth } from "./stores/useAuth";

ReactGA.initialize("G-6W85C1S7BY");

export default function MiniKitProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(true);
  const [setUserInfo] = useAuth(useShallow((state) => [state.setUserInfo]));

  useEffect(() => {
    MiniKit.install(CONSTANTS.APP_ID);

    console.log("Is MiniKit installed correctly? ", MiniKit.isInstalled(true));

    if (MiniKit.isInstalled()) {
      setOpen(true);
    }
  }, []);

  useEffect(() => {
    const searParams = new URLSearchParams(window?.location?.search);
    const a = searParams.get("address");
    if (a) {
      setUserInfo({
        address: a,
        profile_picture_url: CONSTANTS.DEFAULT_AVATAR,
        username: "Unknown",
      });
    }
  }, [setUserInfo]);

  useEffect(() => {
    function listen(event: any) {
      const target = event.target.closest(
        "div[data-action],a[data-action],button[data-action],li[data-action]"
      );

      if (!target) {
        return;
      }

      const action = target.dataset.action;
      const label = target.dataset.label;
      const category = target.dataset.category;
      if (!action) {
        return;
      }
      ReactGA.event({
        category: category || "action",
        action: action,
        label: label,
      });
    }

    document.addEventListener("click", listen);

    return () => document.removeEventListener("click", listen);
  }, []);

  if (!open) {
    return (
      <div className="h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  return <>{children}</>;
}
